import { render } from "./AdditionalMenuMeetings.vue?vue&type=template&id=cfb4ae5c&scoped=true"
import script from "./AdditionalMenuMeetings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdditionalMenuMeetings.vue?vue&type=script&charset=utf-8&lang=js"

import "./AdditionalMenuMeetings.vue?vue&type=style&index=0&id=cfb4ae5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb4ae5c"]])

export default __exports__